import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentRsUser } from '@app/core/state/user/user.selectors';

export const ComplementaryOrderGuard: CanActivateFn = () => {
  const
    store = inject(Store),
    router = inject(Router),
    currentUser = store.selectSignal(selectCurrentRsUser)()!;

  if (!currentUser) {
    return router.parseUrl('rs-number');
  }

  return currentUser.access.complementaryOrder ? true : router.parseUrl('/rs-number');
};
